import React from 'react';
import PropTypes from 'prop-types';

import PromotionContent from './PromotionContent';
import Modal from '../../../Shared/Modal';
import { closeModal } from '../../../utilities/bannersAndModals';

const PromotionModal = ({ content, cookieName, title, handleCloseModal }) => (
  <Modal onClose={() => closeModal(cookieName, handleCloseModal)} title={title}>
    <PromotionContent content={content} handleCloseModal={handleCloseModal} />
  </Modal>
);

PromotionModal.propTypes = {
  content: PropTypes.shape({}).isRequired,
  cookieName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  handleCloseModal: PropTypes.func
};

PromotionModal.defaultProps = {
  handleCloseModal: () => { }
};

export default PromotionModal;
